// @flow weak

import React from 'react';

const Footer = () => (
  <div className="footer-main">
    All rights reserved | &copy; 2018 Laitkor
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/app/components/footer/Footer.js